import axios from 'axios';
import camelcaseKeys from 'camelcase-keys';

import { ConnectorMetadataDto, ProviderCredential } from '@Models';
import config from '../config';
import { snakeCaseKeys } from './helpers';

// Deliberately a separate axios instance from bopsApi: these endpoints are
// gated by a one-time token in the query string, not an Auth0 bearer token,
// and they live outside the `/client/me/` prefix bopsApi is scoped to.
const api = axios.create({
  baseURL: config.REACT_APP_CORE_API_ROOT_ADDRESS,
  headers: {
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json',
  },
  timeout: Number(config.REACT_APP_API_TIMEOUT_MS) || 120000,
});

const credentialIntakeApi = {
  getConnectors: async (token: string): Promise<ConnectorMetadataDto[]> => {
    const response = await api.get('credential-intake/connectors', { params: { token } });
    return response.data.map((connector: any) => camelcaseKeys(connector, { deep: true }));
  },
  submitCredential: async (token: string, credential: ProviderCredential): Promise<void> => {
    await api.post('credential-intake', snakeCaseKeys(credential), { params: { token } });
  },
};

export default credentialIntakeApi;
